import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCalendar,
  IconCheck,
  IconFileExport,
  IconFileInvoice,
  IconSearch,
  IconStatusChange,
  IconTransferIn,
  IconTransferOut,
} from "@tabler/icons-react";
import Avvvatars from "avvvatars-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { cobalt_blue, green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import DetailDataView from "../../DeliveryConfig/Delivery/DetailDataView";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { BASE_API_DELIVERY } from "../../../config";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReportRequestTransfer = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [search, setSearch] = useState<any>({
    FromDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    ToDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  //data search
  const dataRequestTransferStatusOption = [
    {
      value: "PHIEU_TAO_MOI",
      label: "Phiếu tạo mới",
    },
    {
      value: "XUAT_KHO",
      label: "Xuất kho",
    },
    {
      value: "NHAP_KHO",
      label: "Nhập kho",
    },
    {
      value: "KHOA",
      label: "Khóa",
    },
    {
      value: "HOAN_THANH",
      label: "Hoàn thành",
    },
    {
      value: "DONG_YEU_CAU",
      label: "Đóng yêu cầu",
    },
  ];

  const dataExportStatusOption = [
    { value: "CHUA_XUAT", label: "Chưa xuất" },
    { value: "OPEN", label: "Lưu tạm" },
    { value: "LOCK", label: "Đã xuất" },
  ];

  const dataDeliveryStatusSelect = [
    {
      value: "9",
      label: "Nối chuyến",
    },
    {
      value: "322",
      label: "Nhập lại toàn bộ",
    },
    {
      value: "323",
      label: "Nhập lại một phần",
    },
    {
      value: "261",
      label: "Đã phân công",
    },
    {
      value: "1",
      label: "Lập đơn giao hàng",
    },
    {
      value: "3",
      label: "Đang giao hàng",
    },
    {
      value: "4",
      label: "Đã đến nơi",
    },
    {
      value: "5",
      label: "Đơn hàng giao chưa thành công do Khách hàng",
    },
    {
      value: "6",
      label: "Đơn hàng giao chưa thành công do Hacom",
    },
    {
      value: "7",
      label: "Hàng đã giao",
    },
    {
      value: "281",
      label: "Tiếp nhận",
    },
    {
      value: "8",
      label: "Hủy phân công",
    },
    {
      value: "301",
      label: "Hủy đơn",
    },
  ];

  const dataImportStatusOption = [
    { value: "CHUA_NHAP", label: "Chưa nhập" },
    { value: "OPEN", label: "Đang nhập" },
    { value: "LOCK", label: "Phiếu khóa" },
  ];

  const dataTblInventoryTransactionType = [
    {
      label: "Điều chuyển chi nhánh",
      value: "DIEU_CHUYEN_CHI_NHANH",
    },
    {
      label: "Điều chuyển chi nhánh serial",
      value: "DIEU_CHUYEN_CHI_NHANH_SERIAL",
    },
    {
      label: "Xuất kho hủy",
      value: "XUAT_HUY",
    },
    {
      label: "Xuất kho điều chỉnh",
      value: "XUAT_DIEU_CHINH",
    },
    {
      label: "Điều chuyển nội bộ",
      value: "DIEU_CHUYEN_NOI_BO",
    },
    {
      label: "Điều chuyển nội bộ serial",
      value: "DIEU_CHUYEN_NOI_BO_SERIAL",
    },
    {
      label: "Xuất trả NCC",
      value: "XUAT_TRA_NCC",
    },
    {
      label: "Đổi linh kiện",
      value: "DOI_LINH_KIEN",
    },
    {
      label: "Xuất công cụ/dụng cụ",
      value: "XUAT_CONG_CU_DUNG_CU",
    },
  ];

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "soCt",
        header: "Số chứng từ (Điều chuyển)",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() =>
                detailDC(renderedCellValue?.toString() ?? "")
              }
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "loaiPhieuDc",
        header: "Loại phiếu điều chuyển",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorType(renderedCellValue?.toString() ?? null)}
            variant="light"
            bd={`1px solid ${getColorType(
              renderedCellValue?.toString() ?? null,
            )}`}
          >
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataTblInventoryTransactionType,
              "label",
            )}
          </Badge>
        ),
      },
      {
        accessorKey: "trangThai",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge color={getColorTrangThai(renderedCellValue)}>
              {getValueById(
                renderedCellValue?.toString() ?? "",
                dataRequestTransferStatusOption,
                "label",
              )}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "lyDo",
        header: "Lý do YCDC",
      },
      {
        accessorKey: "tgYc",
        header: "Thời gian yêu cầu",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tuTenCn",
        header: "Điều chuyển từ chi nhánh",
        size: 250,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {row.original.tuMaCn} - {renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tuTenKho",
        header: "Điều chuyển từ kho",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {row.original.tuMaKho} - {renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "denTenCn",
        header: "Điều chuyển đến chi nhánh",
        size: 250,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {row.original.denMaCn} - {renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "denTenKho",
        header: "Điều chuyển đến kho",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {row.original.denMaKho} - {renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenNvDc",
        header: "Nhân viên điều chuyển",
        size: 225,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.maNvDc} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "soCtXuat",
        header: "Số chứng từ (Xuất kho)",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          // <Tooltip label="Xem chi tiết">
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
            // onDoubleClick={() =>
            //   detailXK(row.original.soCtXuat, row.original.loaiPhieuXuat)
            // }
          >
            {renderedCellValue === null ? "Chưa xuất kho" : renderedCellValue}
          </Badge>
          // </Tooltip>
        ),
      },
      {
        accessorKey: "ttXuat",
        header: "Trạng thái xuất kho",
        Cell: ({ renderedCellValue }) => (
          <Badge color={getColorTtXuatNhap(renderedCellValue)}>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataExportStatusOption,
              "label",
            )?.toUpperCase()}
          </Badge>
        ),
      },
      {
        accessorKey: "tgHtXuat",
        header: "Thời gian hoàn thành xuất kho",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 275,
      },
      {
        accessorKey: "tenNvXuat",
        header: "Nhân viên xuất kho",
        size: 200,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.maNvXuat} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ctGv",
        header: "Số chứng từ (Giao vận)",
        size: 250,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="lg"
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => detailGV(row.original.idGv)}
              >
                {renderedCellValue === null
                  ? "Chưa giao hàng"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue === null
                ? "Chưa giao hàng"
                : renderedCellValue}
            </Badge>
          ),
      },
      {
        accessorKey: "ttGv",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue }) => (
          <Badge color={getColorTtGv(renderedCellValue?.toString() ?? "")}>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataDeliveryStatusSelect,
              "label",
            )?.toUpperCase()}
          </Badge>
        ),
      },
      {
        accessorKey: "tgGvLh",
        header: "Thời gian giao vận lấy hàng",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 275,
      },
      {
        accessorKey: "tgHtGv",
        header: "Thời gian giao hàng",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tenNvGv",
        header: "Nhân viên giao hàng",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.maNvGv} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "soCtNhap",
        header: "Số chứng từ (Nhập kho)",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Chưa nhập kho" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "ttNhap",
        header: "Trạng thái nhập kho",
        Cell: ({ renderedCellValue }) => (
          <Badge color={getColorTtXuatNhap(renderedCellValue)}>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataImportStatusOption,
              "label",
            )?.toUpperCase()}
          </Badge>
        ),
      },
      {
        accessorKey: "tgHtNhap",
        header: "Thời gian hoàn thành nhập kho",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 275,
      },
      {
        accessorKey: "tenNvNhap",
        header: "Nhân viên nhập kho",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.maNvNhap} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
      },
    ],
    [
      dataRequestTransferStatusOption,
      dataExportStatusOption,
      dataDeliveryStatusSelect,
      dataImportStatusOption,
    ],
  );

  const getColorTrangThai = (text: any) => {
    switch (text) {
      case "XUAT_KHO":
        return "#87de57";
      case "NHAP_KHO":
        return "teal";
      case "PHIEU_TAO_MOI":
        return "blue";
      case "KHOA":
        return "red";
      case "HOAN_THANH":
        return "green";
      case "DONG_YEU_CAU":
        return "gray";
      case "QUAN_LY_TU_CHOI":
      case "DPV_TU_CHOI":
        return "red";
      case null:
        return "rgba(0, 0, 0, 0)";
      default:
        return "rgba(255, 0, 0, 0)";
    }
  };

  const optionColorTrangThai: Record<
    | "PHIEU_TAO_MOI"
    | "NHAP_KHO"
    | "XUAT_KHO"
    | "KHOA"
    | "HOAN_THANH"
    | "DONG_YEU_CAU",
    string
  > = {
    PHIEU_TAO_MOI: "#228BE6",
    NHAP_KHO: "#12B886",
    XUAT_KHO: "#87DE57",
    KHOA: "red",
    HOAN_THANH: "green",
    DONG_YEU_CAU: "gray",
  };

  const renderSelectOptionTrangThai: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorTrangThai[
            option.value as
              | "PHIEU_TAO_MOI"
              | "NHAP_KHO"
              | "XUAT_KHO"
              | "KHOA"
              | "HOAN_THANH"
              | "DONG_YEU_CAU"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const getColorTtXuatNhap = (text: any) => {
    switch (text) {
      case "OPEN":
        return "yellow";
      case "LOCK":
        return green.light;
      default:
        return "rgba(255, 0, 0, 0)";
    }
  };

  const optionColorTtXuatNhap: Record<
    "OPEN" | "LOCK" | "CHUA_XUAT" | "CHUA_NHAP",
    string
  > = {
    OPEN: "yellow",
    LOCK: green.light,
    CHUA_XUAT: "blue",
    CHUA_NHAP: "blue",
  };

  const renderSelectOptionTtXuatNhap: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorTtXuatNhap[
            option.value as "OPEN" | "LOCK" | "CHUA_NHAP" | "CHUA_XUAT"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const getColorTtGv = (text: string) => {
    switch (text) {
      case "261":
        return "lime";
      case "1":
        return "green";
      case "3":
        return "teal";
      case "5":
        return "blue";
      case "6":
        return "indigo";
      case "7":
        return "violet";
      case "8":
        return "red";
      case "4":
        return "#2bdd66";
      case "9":
        return "yellow";
      case "301":
        return "#c91a25";
      case null:
        return "rgba(0, 0, 0, 0)";
      default:
        return "rgba(0, 0, 0, 0)";
    }
  };

  const optionColorsTtGv: Record<
    | "Đã phân công"
    | "Lập đơn giao hàng"
    | "Đang giao hàng"
    | "Đã đến nơi"
    | "Đơn hàng giao chưa thành công do Khách hàng"
    | "Đơn hàng giao chưa thành công do Hacom"
    | "Hàng đã giao"
    | "Hàng đã giao - nối chuyến"
    | "Hủy phân công"
    | "Nối chuyến"
    | "Hủy đơn",
    string
  > = {
    "Đã phân công": "lime",
    "Lập đơn giao hàng": "green",
    "Đang giao hàng": "teal",
    "Đã đến nơi": "cyan",
    "Đơn hàng giao chưa thành công do Khách hàng": "blue",
    "Đơn hàng giao chưa thành công do Hacom": "indigo",
    "Hàng đã giao": "violet",
    "Hàng đã giao - nối chuyến": "grape",
    "Hủy phân công": "red",
    "Hủy đơn": "#c91a25",
    "Nối chuyến": "yellow",
  };

  const renderSelectOptionTtGv: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsTtGv[
            option.label as
              | "Đã phân công"
              | "Lập đơn giao hàng"
              | "Đang giao hàng"
              | "Đã đến nơi"
              | "Đơn hàng giao chưa thành công do Khách hàng"
              | "Đơn hàng giao chưa thành công do Hacom"
              | "Hàng đã giao"
              | "Hàng đã giao - nối chuyến"
              | "Hủy phân công"
              | "Hủy đơn"
              | "Nối chuyến"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const getColorType = (type: string | null) => {
    switch (type) {
      case "DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case "XUAT_HUY":
        return "#d9d02f";
      case "XUAT_DIEU_CHINH":
        return "#6bd731";
      case "DIEU_CHUYEN_NOI_BO":
        return "#09b8ff";
      case "DIEU_CHUYEN_NOI_BO_SERIAL":
        return "#1f32c4";
      case "DOI_LINH_KIEN":
        return "#c92a2a";
      case "XUAT_TRA_NCC":
        return "#2bdd66";
      case "DOI_LINH_KIEN":
        return "#f01879";
      case "XUAT_CONG_CU_DUNG_CU":
        return "#4c5897";
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const optionColorType: Record<
    | "DIEU_CHUYEN_CHI_NHANH"
    | "DIEU_CHUYEN_CHI_NHANH_SERIAL"
    | "XUAT_HUY"
    | "XUAT_DIEU_CHINH"
    | "DIEU_CHUYEN_NOI_BO"
    | "DIEU_CHUYEN_NOI_BO_SERIAL"
    | "XUAT_TRA_NCC"
    | "DOI_LINH_KIEN"
    | "XUAT_CONG_CU_DUNG_CU",
    string
  > = {
    DIEU_CHUYEN_CHI_NHANH: "#f06418",
    DIEU_CHUYEN_CHI_NHANH_SERIAL: "#ffab09",
    XUAT_HUY: "#d9d02f",
    XUAT_DIEU_CHINH: "#6bd731",
    DIEU_CHUYEN_NOI_BO: "#09b8ff",
    DIEU_CHUYEN_NOI_BO_SERIAL: "#1f32c4",
    XUAT_TRA_NCC: "#2bdd66",
    DOI_LINH_KIEN: "#f01879",
    XUAT_CONG_CU_DUNG_CU: "#4c5897",
  };

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorType[
            option.value as
              | "DIEU_CHUYEN_CHI_NHANH"
              | "DIEU_CHUYEN_CHI_NHANH_SERIAL"
              | "XUAT_HUY"
              | "XUAT_DIEU_CHINH"
              | "DIEU_CHUYEN_NOI_BO"
              | "DIEU_CHUYEN_NOI_BO_SERIAL"
              | "XUAT_TRA_NCC"
              | "DOI_LINH_KIEN"
              | "XUAT_CONG_CU_DUNG_CU"
          ]
        }
        bd={`1px solid ${
          optionColorType[
            option.value as
              | "DIEU_CHUYEN_CHI_NHANH"
              | "DIEU_CHUYEN_CHI_NHANH_SERIAL"
              | "XUAT_HUY"
              | "XUAT_DIEU_CHINH"
              | "DIEU_CHUYEN_NOI_BO"
              | "DIEU_CHUYEN_NOI_BO_SERIAL"
              | "XUAT_TRA_NCC"
              | "DOI_LINH_KIEN"
              | "XUAT_CONG_CU_DUNG_CU"
          ]
        }`}
        radius="sm"
        variant="light"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const detailDC = (sourceCode: string) => {
    navigate("/warehouse-config/detail-request-transfer", {
      state: { sourceCode: sourceCode },
    });
  };

  // const detailXK = (transactionCode: string, type: string) => {
  //   navigate("/warehouse-config/detail-warehouse-out-ward", {
  //     state: { transactionCode: transactionCode, type: type, isLocked: true },
  //   });
  // };

  function detailGV(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem chi tiết !</Title>
        </>
      ),
      size: "auto",
      children: <DetailDataView id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/RequestTransfer/get-list-request-transfer-report?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryDelivery.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleExportExcel = async () => {
    open();
    try {
      let url = `/api/v1/RequestTransfer/export-request-transfer-report?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_yeu_cau_dieu_chuyen" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem(
        "reportRequestTransferColumnPinning",
      );
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : { left: ["mrt-row-numbers"], right: ["action"] }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return { left: ["mrt-row-numbers"], right: ["action"] };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem(
        "reportRequestTransferColumnPinning",
        JSON.stringify(columnPinning),
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.maCtkm,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: setColumnPinning,
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconFileExport size={14} />}
            onClick={() => handleExportExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Loại phiếu điều chuyển"
              clearable
              leftSection={<IconFileInvoice color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              searchable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              data={dataTblInventoryTransactionType}
              renderOption={renderSelectOptionType}
              value={search?.LoaiPhieuDC}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "LoaiPhieuDc", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder={"Trạng thái phiếu điều chuyển"}
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataRequestTransferStatusOption}
              value={search?.TrangThai}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "TrangThai", setSearch);
              }}
              renderOption={renderSelectOptionTrangThai}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder={"Trạng thái phiếu xuất kho"}
              clearable
              data={dataExportStatusOption}
              leftSection={<IconTransferOut color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              value={search?.TtXuat}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "TtXuat", setSearch)
              }
              renderOption={renderSelectOptionTtXuatNhap}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái giao vận"
              clearable
              data={dataDeliveryStatusSelect}
              leftSection={<IconStatusChange color="#15aabf" />}
              value={search?.TtGv}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "TtGv", setSearch);
              }}
              comboboxProps={{
                width: 400,
                transitionProps: { transition: "pop", duration: 200 },
              }}
              renderOption={renderSelectOptionTtGv}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder={"Trạng thái phiếu nhập kho"}
              clearable
              data={dataImportStatusOption}
              leftSection={<IconTransferIn color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              value={search?.TtNhap}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "TtNhap", setSearch)
              }
              renderOption={renderSelectOptionTtXuatNhap}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "FromDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "ToDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ReportRequestTransfer;
